import store from '../store';
import router from ".";
import { isLoginCheck, isNotLoginCheck } from './loginGuard';
import { isNotReadyFlatformCheck, isNotReadyContentCheck } from './pageGuard';

export default [
    //메인
    {
        path: '/kr/index.do',
        component: () => import('../views/kr/main/MainView.vue'),
        children: [{
            path: '/',
            component: () => import('../views/kr/main/MainView.vue')
        }],        
        beforeEnter: (to, from, next) => {
            if(window.location.hostname == 'rnd.kumc.or.kr') {
                router.replace('/');
            }
            if (window.location.pathname == '/') {
                window.location.pathname = '/kr/index.do';
            } else {
                return next();
            }
        },
        meta: {
            title : '연구중심병원'
        }
    },
    //팝업(메인 새창)
    {
        path: '/kr/popup.do',
        component: () => import ('../views/kr/popup/PopupMainView.vue')
    },
    //통합검색
    {
        path: '/kr/search.do',
        component: () => import ('../views/kr/main/SearchView.vue')
    },
    //로그인
    {
        path: '/kr/login.do',
        component: () => import ('../views/kr/login/LoginView.vue'),
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '로그인');
        }
    },
    //  비밀번호 변경 : 로그인상태
    {
        path: '/kr/help/pw/change.do',
        component: () => import ('../views/kr/help/PwChangeView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },
    //HELP
    // 아이디 찾기
    {
        path: '/kr/help/id/inquiry.do',
        component: () => import ('../views/kr/help/IdInquiryView.vue'),
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '아이디 찾기');
        }
    },
    {
        path: '/kr/help/id/resolution.do',
        name: 'idResolution',
        component: () => import('../views/kr/help/IdResolutionView.vue'),
        beforeEnter: (to, from, next) => {
            if (store.state.loginTypeStore.status == true) {
                alert(`로그인이 되어있습니다.\n아이디 찾기를 하려면 로그아웃을 해주시길 바랍니다.`);
                router.replace('/kr/index.do');
            } else if (store.state.registInfoStore.memFinishEmail == '') {
                alert(`잘못된 접근입니다.`);
                router.replace('/kr/index.do');
            } else {
                return next();
            }
        }
    },    
    //  비밀번호 찾기
    {
        path: '/kr/help/pw/inquiry.do',
        component: () => import ('../views/kr/help/PwInquiryView.vue'),
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '비밀번호 찾기');
        }
    },
    {
        path: '/kr/help/pw/resolution.do',
        name: 'passwordResolution',
        component: () => import('../views/kr/help/PasswordResolutionView.vue'),
        beforeEnter: (to, from, next) => {
            if (store.state.loginTypeStore.status == true) {
                alert(`로그인이 되어있습니다.\n비밀번호 찾기를 하려면 로그아웃을 해주시길 바랍니다.`);
                router.replace('/kr/index.do');
            } else if (store.state.registInfoStore.memFinishEmail == '') {
                alert(`잘못된 접근입니다.`);
                router.replace('/kr/index.do');
            } else {
                return next();
            }
        }
    },     
    //회원가입
    //  회원구분
    {
        path: '/kr/account/regist/intro.do',
        component: () => import('../views/kr/account/Step1View.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '회원가입');
        }
    },
    //  동의
    {
        path: '/kr/account/regist/step1.do',
        component: () => import('../views/kr/account/Step1View.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '회원가입');
        }
    },
    //  인증
    {
        path: '/kr/account/regist/step2.do',
        component: () => import('../views/kr/account/Step2View.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '회원가입');
        }
    },
    //  가입FORM
    {
        path: '/kr/account/regist/step3.do',
        component: () => import('../views/kr/account/Step3View.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '회원가입');
        }
    },
    //  가입완료
    {
        path: '/kr/account/regist/complete.do',
        component: () => import('../views/kr/account/CompleteView.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '회원가입');
        }
    },
    // 개인정보 재동의
    {
        path: '/kr/account/re-agree.do',
        component: () => import('../views/kr/account/ReAgreeView.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '개인정보 재동의');
        }
    },
    // 휴면계정 안내
    {
        path: '/kr/account/reactivate-dormant-account.do',
        component: () => import('../views/kr/account/ReactivateDormantView.vue'),       
        beforeEnter: (to, from, next) => {
            isLoginCheck(next, '휴면계정 안내');
        }
    },
    
    // 휴면회원
    {
        path: '/kr/login/sleep.do',
        name: 'sleep',
        component: () => import('../views/kr/login/SleepView.vue'),
    },
    // // 휴면회원 수정
    // {
    //     path: '/:lang/login/sleepModify.do',
    //     name: 'sleepModify',
    //     component: () => import('../views/login/SleepModifyView.vue'),
    // },

    //본인인증 완료
    {
        path: '/kr/member/chk_success.do',
        name: 'checkSuccess',
        component: () => import('../views/kr/common/CheckSuccessView.vue')
    },

     //인터넷이용약관
     {
        path: '/kr/service/RullInternet.do',
        component: () => import('../views/kr/service/RullInternetView.vue')
    },
    //개인정보처리방침
    {
        path: '/kr/service/privacy.do',
        component: () => import('../views/kr/service/PrivacyView.vue')
    },
    //구로,안산 교육일정
    {
        path: '/kr/eduSchedule/month.do',
        component: () => import('../views/kr/education/EduScheduleMonthView.vue')
    },

    
    
    //장비소개 :classCD
    //  연구지원
    //      /kr/support/anam/equip
    //      /kr/support/guro/equip
    //      /kr/support/ansan/equip
    //  연구장비
    //      /kr/equipment/micro/equip
    //      /kr/equipment/common/equip
    //      /kr/equipment/manufacture/equip
    //      /kr/equipment/isotope/equip     
    // 구로 - 연구장비 신청
    {
        path: '/kr/guro/equip/list.do',   
        component: () => import('../views/kr/support/EquipListView.vue'),
    },     
    // 구로 - 연구장비 신청
    {
        path: '/kr/guro/equip/view.do',   
        component: () => import('../views/kr/support/EquipDetailView.vue'),
    },
    // 안산 - 연구장비 신청
    {
        path: '/kr/ansan/equip/list.do',   
        component: () => import('../views/kr/support/EquipListView.vue'),
    },     
    // 안산 - 연구장비 신청
    {
        path: '/kr/ansan/equip/view.do',   
        component: () => import('../views/kr/support/EquipDetailView.vue'),
    },
    {
        path: '/kr/:pageCd/:mgrpCd/equip/list.do',
        component: () => import('../views/kr/support/EquipListView.vue'),
    },
    {
        path: '/kr/:pageCd/:mgrpCd/equip/view.do',
        component: () => import('../views/kr/support/EquipDetailView.vue'),
    },
    //강의지원
     //IP신청 - 제1의학관 - 입력폼
     {
        path: '/kr/lecture/ip/first.do',   
        component: () => import('../views/kr/lecture/IpFirstView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    }, 
    // 강의실소개 : classCD
    // /kr/lecture/hall/main
    // /kr/lecture/hall/first
    // /kr/lecture/hall/headquarters
    // /kr/lecture/hall/bio
    // /kr/lecture/hall/special
    {
        path: '/kr/lecture/hall/guro.do',   
        component: () => import('../views/kr/lecture/HallListView.vue'),
    },
    {
        path: '/kr/lecture/hall/anam.do',   
        component: () => import('../views/kr/lecture/HallListView.vue'),
    },
    {
        path: '/kr/lecture/hall/anam1.do',   
        component: () => import('../views/kr/lecture/HallListView.vue'),
    },
    {
        path: '/kr/lecture/hall/anam2.do',   
        component: () => import('../views/kr/lecture/HallListView.vue'),
    },
    // 구로 - 연구공간 임대
    {
        path: '/kr/reserch-support/guro.do',
        component: () => import('../views/kr/lecture/HallNoReservListView.vue'),
    },

    //컨설팅
    // /kr/consult/flatformprofessor/list
    // /kr/consult/info
    {
        path: '/kr/consult/flatformprofessor/list.do',   
        component: () => import('../views/kr/consult/FlatformProfessorListView.vue'),
    },     
    //컨설팅
     // 예약 아닌 컨설팅신청 폼
    // 안암
    {
        path: '/kr/rnd/anam/consult.do',
        component: () => import('../views/kr/consult/consultFormAnamView.vue'),
        // beforeEnter: (to, from, next) => {
        //     isNotLoginCheck(to, from, next);
        // }
    },
    //안산,구로
    {
        path: '/kr/rnd/:pageCd/consult.do',   
        component: () => import('../views/kr/consult/consultFormView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },

    //개방형 의료 R&D 플랫폼
    // /kr/flatform/:pageCd/info
    // /kr/flatform/:pageCd/professor
    // /kr/flatform/:pageCd/professor/detail.do
    {
        path: '/kr/flatform/:pageCd/info.do',   
        component: () => import('../views/kr/flatform/FlatformInfoView.vue'),
        beforeEnter: (to, from, next) => {
            isNotReadyFlatformCheck(to, from, next);
        },
    },
    {
        path: '/kr/flatform/:pageCd/professor/list.do',   
        component: () => import('../views/kr/flatform/FlatformProfessorView.vue'),
    },
    {
        path: '/kr/flatform/:pageCd/professor/view.do',   
        component: () => import('../views/kr/flatform/ProfessorDetailView.vue'),
    },
    //예약시스템    
    // 대관현황
    // /kr/reserve/hall/current/month / week
    // /kr/reserve/equip/current/month
    // /kr/reserve/consult/current/month
    {
        path: '/kr/reserve/:pageCd/current/month.do',   
        component: () => import('../views/kr/reserve/CurrentMonthView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    }, 
    {
        path: '/kr/reserve/:pageCd/current/week.do',   
        component: () => import('../views/kr/reserve/CurrentWeekView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    }, 

    // 대관신청
    // /kr/reserve/hall/application
    // /kr/reserve/equip/application
    // /kr/reserve/consult/application
    {
        path: '/kr/reserve/:pageCd/application.do',   
        component: () => import('../views/kr/reserve/ApplicationView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    }, 
    
    //마이페이지
    // 공간예약내역
    {
        path: '/kr/mypage/reserve/hall.do',
        component: () => import('../views/kr/mypage/reserveHallView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },    
    // 장비예약내역
    {
        path: '/kr/mypage/reserve/equip.do',
        component: () => import('../views/kr/mypage/reserveEquipView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },    
    // 컨설팅신청내역
    {
        path: '/kr/mypage/reserve/consult.do',
        component: () => import('../views/kr/mypage/reserveConsultView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },
    //공동연구 컨설팅지원 신청내역(예약기능X)
    {
        path: '/kr/mypage/reserve/consultapply.do',
        component: () => import('../views/kr/mypage/notReserveConsultView.vue'),       
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }

    },
    //  회원정보 - 개인정보수정
    {
        path: '/kr/mypage/info/modify.do',
        component: () => import('../views/kr/mypage/infoModifyView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },    
    //  회원정보 - 비밀번호변경
    {
        path: '/kr/mypage/info/password.do',
        component: () => import('../views/kr/mypage/infoPasswordView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },  
    //  회원정보 - 회원탈퇴
    {
        path: '/kr/mypage/info/withdraw.do',
        component: () => import('../views/kr/mypage/infoWithdrawView.vue'),
        beforeEnter: (to, from, next) => {
            isNotLoginCheck(to, from, next);
        }
    },

    // contents 
    
    {
        path: '/kr/:path1/:path2.do',
        // alias: [
        //     '/kr/aboutus/overview.do',
        //     '/kr/aboutus/rule.do',
        //     '/kr/aboutus/organization.do',
        //     '/kr/aboutus/history.do',
        //     '/kr/aboutus/history-person.do',
        //     '/kr/aboutus/member.do',
        //     '/kr/aboutus/animal.do',
        //     '/kr/aboutus/creature.do' 
        // ],
        component: () => import('../views/kr/contents/ContentsView.vue'),
        children: [{
            path: '/kr/:path1/:path2/:path3.do',
            component: () => import('../views/kr/contents/ContentsView.vue')
        }],
        beforeEnter: (to, from, next) => {
            isNotReadyContentCheck(to, from, next);
        }
    },
       
    //board
    {
        path: '/kr/:path1/list.do',
        component: () => import('../views/kr/boards/BoardListView.vue'),
        alias: [
            '/kr/:path1/:path2/list.do',
            '/kr/:path1/:path2/:path3/list.do',
        ]
    },
    {
        path: '/kr/:path1/view.do',
        component: () => import('../views/kr/boards/BoardDetailView.vue'),
        alias: [
            '/kr/:path1/:path2/view.do',
            '/kr/:path1/:path2/:path3/view.do',
        ]
    },
    //{
    //    path: '/kr/:path1/:path2/list.do',
    //    component: () => import('../views/kr/boards/BoardListView.vue'),
    //    children: [{
    //        path: '/kr/:path1/:path2/:path3/list.do',
    //        component: () => import('../views/kr/boards/BoardListView.vue')
    //    }]
    //},
    //{
    //    path: '/kr/:path1/:path2/view.do',
    //    component: () => import('../views/kr/boards/BoardDetailView.vue'),
    //    children: [{
    //        path: '/kr/:path1/:path2/:path3/view.do',
    //        component: () => import('../views/kr/boards/BoardDetailView.vue')
    //    }]
    //},
    
    {
        path: '/:pathMatch(.*)*',
        name: 'error',
        component: () => import('../views/kr/error/Error.vue'),
    },
];
